/**
 * Function detects when main page images (any loaded inside
 * responsive picture element) are fully loaded before showing
 * grain texture overlay.
 */
const ImagesLoaded = (function () {
  const handleImageLoad = (e) => {
    updateImageLoadedClass(e.target)
  }

  const updateImageLoadedClass = (imgEl) => {
    const pictureEl = imgEl.closest('picture')
    if (pictureEl) {
      pictureEl.classList.add('loaded')
    }
  }

  return {
    init: () => {
      const pictureEls = document.querySelectorAll('picture img')
      pictureEls.forEach((img) => {
        if (img.complete) {
          updateImageLoadedClass(img)
        } else {
          img.addEventListener('load', handleImageLoad)
        }
      })
    },
    kill: () => {
      const pictureEls = document.querySelectorAll('picture img')
      pictureEls.forEach((img) => {
        img.removeEventListener('load', handleImageLoad)
      })
    },
  }
})()

export default ImagesLoaded
